var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-box"},[_c('div',{staticClass:"tab flex"},_vm._l((_vm.tab),function(item,i){return _c('div',{key:i,staticClass:"item flex-grow flex-center",class:{'z-crt': _vm.currentIndex == i},on:{"click":function($event){return _vm.clickHandle(i)}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }